import * as React from 'react'
import Modal from '@mui/material/Modal'
import CustomView from '@/components/CustomView'
import CustomGraphy from '@/components/CustomGraphy'
import CustomButton from '@/components/CustomButton'
import CloseIcon from '@mui/icons-material/Close'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: '600px',
  borderRadius: '8px',
  border: '1.5px solid #C4C4C4',
  boxShadow: 24,
  p: 4
}

interface IModalIntegration {
  isOpen: boolean
  handleClose: () => void
  handleConfirm: () => void
  confirmDisabled?: boolean
  children: React.ReactNode
}

function ModalIntegration({
  isOpen,
  handleClose,
  handleConfirm,
  confirmDisabled,
  children
}: IModalIntegration) {
  return (
    <CustomView width="unset">
      <Modal keepMounted open={isOpen} onClose={handleClose}>
        <CustomView backColor="white" sx={style}>
          <CustomView
            flexDirection="row"
            justifyContent="space-between"
            style={{ borderBottom: '1px solid #f8f8f8', padding: '5px' }}
          >
            <CustomGraphy fontSize={20}>Integração</CustomGraphy>
            <CustomView
              onClick={handleClose}
              style={{ cursor: 'pointer', color: '#2C2C2C' }}
              width="unset"
            >
              <CloseIcon fontSize="large" />
            </CustomView>
          </CustomView>
          {children}
          <CustomView
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-end"
            gap={4}
            backColor="white"
          >
            <CustomButton
              variable="default"
              onClick={handleClose}
              style={{ marginTop: '15px' }}
            >
              Cancelar
            </CustomButton>
            <CustomButton
              style={{
                marginTop: '15px',
                width: '100%',
                maxWidth: '192px'
              }}
              variable={confirmDisabled ? 'disabled' : 'contained'}
              disabled={confirmDisabled}
              onClick={handleConfirm}
            >
              Processar
            </CustomButton>
          </CustomView>
        </CustomView>
      </Modal>
    </CustomView>
  )
}

export default ModalIntegration
